






import Vue from 'vue'

export default Vue.extend({
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
    },
    backgroundColor: {
      type: String
    },
    borderColor: {
      type: String,
    },
  },
  computed: {
    submitStyle(): {color: string} {
      let ret: any = {}
      if (this.backgroundColor) {
        ret['background-color'] = this.backgroundColor
      }
      if (this.color) {
        ret['color'] = this.color
      }
      if (this.borderColor) {
        ret['border-color'] = this.borderColor
      }
      return ret
    }
  },
  methods: {
    onClick() {
      this.$emit('on-click')
    }
  }
})
